<template>
<!-- 慕课详情 -->
    <div class="mooc_detail_warp">
        <BaseDetail ref="baseDetail">
            <template slot="top" scope="{info}">
                <div class="video_box">
                    <div class="video_l">
                        <!-- 视频 -->
                        <div class="video_l_content" v-if="playVideo">
                            <video ref="audio" controls="controls" width="100%" height="100%" :src="info.sourceUrl" autoplay></video>
                        </div>
                        <div class="video_l_content" v-if="!playVideo">
                            <img class="video_img" :src="info.cover" alt="">
                            <div class="tip">报名后，才可观看···</div>
                        </div>
                        <div class="video_l_footer">
                            <div class="cont_top_title">{{info.title}}</div>
                            <div class="behavior_box">
                                <div style="color:#2f69ed;">播放 0 </div>
                                <div class="behavior_list">
                                    <div class="behavior_item" @click="operation(0)">
                                        <svg-icon icon-class="thumb" :class="operCount.ydz? 'active_icon': ''" class="item_icon" />
                                        {{operCount.dzs}}
                                    </div>
                                    <div class="behavior_item" @click="operation(1)">
                                        <i class="el-icon-star-off item_icon" :class="operCount.ysc? 'active_icon': ''"  />
                                        {{operCount.scs}}
                                    </div>
                                    <!-- <div class="behavior_item">
                                        <i class="el-icon-share item_icon"/> 分享
                                    </div> -->
                                </div>
                                <el-button type="primary" @click="operation(2)" v-show="!readerId || operCount.ybm===0">我要报名</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="video_r" >
                        <div class="video_r_title">课件</div>
                        <div class="video_r_list" v-if="false">
                            <div class="r_list_item">
                                <i class="el-icon-video-play play_icon"></i>
                                <span class="name ellipsis">哈么妮合唱工作坊·青年指挥家邓卓锐公益课堂   第一节</span>
                                <span>43:57</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div slot="cont" class="cont_warp">
               
            </div>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { post } from '@u/request'
import { mapGetters } from 'vuex'
const urls = [
    {url: 'praise',message: '点赞成功！'},
    {url: 'collect',message: '收藏成功！'},
    {url: 'mycourse',message: '报名成功！'},
]

export default {
    name: 'moocDetail',
    components: {
        BaseDetail
    },
    data() {
        return {
            playVideo: false,
            operCount: {}
        }
    },
    computed: {
        ...mapGetters([
            'readerId',
        ]),
        contentId() {
            return this.$route.params.id
        }
    },
	watch: {
	    'readerId'(value){
		    this.operinfo()
	    }
	},
    methods: {

        async operation(index) {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (index == 0 && this.operCount.ydz) {
                this.$message.success('已经点赞啦！');
                return;
            }
            if (index == 1 && this.operCount.ysc) {
                this.$message.success('已经收藏啦！');
                return;
            }
            if (index == 2 && this.operCount.ybm) {
                this.$message.success('已经报名啦！');
                return;
            }
            const currentUrl = urls[index]
            const params = {
                readerId: this.readerId,
                courseId: this.contentId
            }
            const { data } = await post(`resource/${currentUrl.url}/add`, params);
            if (index === 2) {
                this.playVideo = true;
            }
            this.$message.success(currentUrl.message)
            this.operinfo()
        },

        async operinfo() {
            const params = {
                readerId: this.readerId,
                courseId: this.contentId
            }
            const { data } = await post('resource/showapi/operinfo', params);
            this.operCount = data;
			//console.log(this.operCount.ybm)
			if(this.operCount.ybm){
				this.playVideo = true;
			}
			if(!this.readerId){
				this.playVideo = false
			}
        }
    },
    mounted() {
        this.$refs.baseDetail.videoLoad('offlinesource')
        this.$refs.baseDetail.loadCommentList('courseId')
        this.operinfo()
    }
}
</script>

<style scoped lang="scss">
.mooc_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    padding-top: 20px;
    .video_box {
        width: 100%;
        background: #000;
        display: flex;
        
        box-sizing: border-box;
        .video_l {
            width: 845px;
            border-right: 1px solid #919191;
        }
        .video_l_content {
            height: 477px;
            position: relative;
            .tip {
                position: absolute;
                top: 45%;
                left: 0;
                width: 100%;
                text-align: center;
                color: #fff;
                font-size: 24px;
            }
        }
        .video_img {
            width: 100%;
            height: 100%;
        }
        .video_l_footer {
            padding: 27px 30px 30px;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #fff;
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-right: auto;
            margin-left: 20px;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
        .video_r {
            flex: 1;
            overflow: hidden;
        }
        .video_r_list {
            height: 600px;
            padding: 20px 20px 0 20px;
            overflow-y: auto;
        }
        .r_list_item {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;            
            margin-bottom: 15px;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            &.active {
                color: #2f7ef7;
            }
            .play_icon {
                font-size: 27px;
            }
            .name {
                flex: 1;
                margin-left: 8px;
            }
        }
        .video_r_title {
            height: 58px;
            padding-left: 20px;
            line-height: 58px;
            text-align: left;
            font-size: 24px;
            font-weight: 800;
            color: #fff;
            border-bottom: 1px solid #919191;
        }
    }
    .cont_warp {
        width: 100%;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
        border-radius: 5px;
        padding: 45px 30px;
    }
    .active_icon {
        color: #a80000;
    }
}
</style>